import React from 'react';
import { FormCtx } from './form-context/form-context';
import { HilbiFormProps } from '@common/types/hilbi-form';

const HilbiForm: React.FC<HilbiFormProps> = ({
  children,
  variation,
  direction,
}) => {
  return (
    <FormCtx.Provider
      value={{
        direction: direction || 'horizontal',
        variation: variation || 'lined',
      }}
    >
      {children}
    </FormCtx.Provider>
  );
};

export default HilbiForm;
